"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ClayPaginationBarWithBasicItems", {
  enumerable: true,
  get: function get() {
    return _PaginationBarWithBasicItems.ClayPaginationBarWithBasicItems;
  }
});
exports.default = void 0;

var _PaginationBar = _interopRequireDefault(require("./PaginationBar"));

var _PaginationBarWithBasicItems = require("./PaginationBarWithBasicItems");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var _default = _PaginationBar.default;
exports.default = _default;